import { observer } from 'mobx-react-lite'
import { View } from 'react-native'
import { BaseModalConfig } from '..'
import { HandWinner, HandWinnerProps } from '../../../HandWinner'
import { styles } from './RoundWinner.style'
import { useStore } from '../../../../../models'
import { PotKind } from '@ppwr/poker'

export interface RoundWinnerProps extends BaseModalConfig, HandWinnerProps {}

export const RoundWinner = observer(() => {
  const {
    game: { winners, isHandWinnersEvent }
  } = useStore()

  const mainPotWinners = winners.filter((w) => w.potKind === PotKind.MAIN)
  const mainPotWinner = mainPotWinners[0]

  if (!(mainPotWinner && isHandWinnersEvent)) return null

  return <HandWinner winnerCardSizes={16} />
})
